/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box } from "@material-ui/core";

import type { FC } from "react";

export const AboutPaymentMethods: FC<{
  isDarkModeEnabled: boolean;
}> = ({ isDarkModeEnabled }) => {
  return (
    <Box color={"#757575"} fontSize={"14px"}>
      FAQ |{" "}
      <a
        href="https://spwn.zendesk.com/hc/ja/sections/11864228603289-%E6%B3%A8%E6%96%87%E5%86%85%E5%AE%B9-%E6%B1%BA%E6%B8%88%E3%81%AB%E3%81%A4%E3%81%84%E3%81%A6"
        target="_blank"
        rel="noopener noreferrer"
        css={css`
          font-weight: 700;
          color: ${isDarkModeEnabled ? "#FFFFFF" : "#000000"};
        `}
      >
        決済方法について
      </a>
    </Box>
  );
};
